import Combobox from "./Combobox.vue";
import { pluginify } from "./../../util";
export default pluginify(Combobox);
export { Combobox };
